
export default {
  name: 'GeneralMeetings',
  fetchOnServer: false,

  data() {
    return {
      show: true,
      generalMeetings: null,
    }
  },
  async fetch() {
    try {
      const meetingRes = await fetch(`${this.$config.apiBaseUrl}/data`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `Command=GetFreshGeneralMeetings&Language=${this.$i18n.locale}&Company=${this.$route.params.SecuritySymbol}`,
      })
      this.generalMeetings = await meetingRes.json()
    } catch (error) {
      // console.log(error)
    }
  },
  mounted() {
    // console.log(this.$i18n.locale)
  },
}
